import { useEffect, useState } from 'react';
import { BsArrowUpRight } from 'react-icons/bs';
import { useLoaderData } from 'react-router-dom';
import { fetchMedicalCenter } from '~/services/medical-centers';
import Breadcrumb from '~/components/Breadcrumbs/Breadcrumb';
import PatientsTab from '~/components/MedicalCenterDetail/PatientsTab';
import ProfessionalsTab from '~/components/MedicalCenterDetail/ProfessionalsTab';
import ReferralsTab from '~/components/MedicalCenterDetail/ReferralsTab';
import Panel from '~/components/Panel';
import Tabs from '~/components/Tabs';
import MedicalCenterTitlePanel from '~/components/MedicalCenterDetail/MedicalCenterTitlePanel';
import EditMedicalCenterDrawer from './EditMedicalCenterDrawer';

export async function loader({ params }: any) {
    const data = await fetchMedicalCenter(params.id);
    return data;
}

const MedicalCenterDetail = () => {
    const { medical_center } = useLoaderData() as any;
    const [medCenter, setMedCenter] = useState<any>(medical_center);
    const count = medical_center?.medical_professionals?.length;
    const patients_count = medical_center?.medical_professionals?.reduce(
        (acc: any, curr: any) => acc + curr.patient_count,
        0
    );

    const [openTab, setOpenTab] = useState(1);
    const [approved, setApproved] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const tabNames = [
        {
            name: 'Professionals',
            count: count,
        },
        { name: 'Patients', count: patients_count },
        { name: 'Referrals', count: 999 },
    ];

    useEffect(() => {
        setApproved(!!medical_center?.approved_by_person_id);
    }, [medical_center]);

    return (
        <>
            <Breadcrumb
                pageName='Medical Center Detail'
                parentPage='Medical Centers'
                parentPath='/medical-centers'
            />

            <Panel>
                <MedicalCenterTitlePanel
                    medCenter={medCenter}
                    approved={approved}
                    setApproved={setApproved}
                />
            </Panel>

            <div className='mt-7.5 grid grid-cols-12 gap-7.5'>
                <div className='col-span-12 mb-7.5 xl:col-span-4'>
                    {!approved && (
                        <div className='mb-7.5'>
                            <Panel addClasses='bg-[#FDEAEB] border-1 border-[#F02D3A]'>
                                <h2 className='font-medium uppercase text-[#F02D3A]'>
                                    Approval Required
                                </h2>
                                Note, this medical center was added by a non
                                Help Hope Live user. The medical center requires
                                approval before this record will show in
                                picklists for other patients to be able to
                                select this medical center for their own
                                campaign.
                            </Panel>
                        </div>
                    )}

                    <Panel>
                        <div className='flex place-content-between items-start'>
                            <div>
                                <h3 className='text-[12px]/[16px] text-[#949599] '>
                                    Location
                                </h3>
                                {medCenter?.city}, {medCenter?.location}{' '}
                                {medCenter?.zipcode}
                                <h3 className='text-[12px]/[16px] text-[#949599] '>
                                    Url
                                </h3>
                                <a
                                    href={medCenter?.url}
                                    target='_blank'
                                    rel='noreferrer'
                                    className='inline-flex items-center gap-1 text-green-600 hover:text-green-700'
                                >
                                    {medCenter?.url}
                                    <BsArrowUpRight />
                                </a>
                                {medCenter?.npi_num && (
                                    <>
                                        <h3 className='text-[12px]/[16px] text-[#949599] '>
                                            NPI
                                        </h3>
                                        {medCenter.npi_num}
                                    </>
                                )}
                            </div>
                            <button
                                onClick={() => setIsDrawerOpen(true)}
                                className='rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white'
                            >
                                EDIT
                            </button>
                        </div>
                    </Panel>
                </div>
                <div className='col-span-12 xl:col-span-8'>
                    <Panel>
                        <Tabs
                            tabNames={tabNames}
                            openTab={openTab}
                            setOpenTab={setOpenTab}
                        >
                            {openTab == 1 ? (
                                <ProfessionalsTab
                                    id={medical_center?.id}
                                    medCenter={{ id: medCenter?.id, name: medCenter?.name }}
                                />
                            ) : (
                                ''
                            )}
                            {openTab == 2 ? (
                                <PatientsTab id={medical_center?.id} />
                            ) : (
                                ''
                            )}
                            {openTab == 3 ? <ReferralsTab /> : ''}
                        </Tabs>
                    </Panel>
                </div>
            </div>
            <EditMedicalCenterDrawer
                isOpen={isDrawerOpen}
                setIsOpen={setIsDrawerOpen}
                medCenter={medCenter}
                setMedCenter={setMedCenter}
            />
        </>
    );
};

export default MedicalCenterDetail;
